import { XmarkSolid } from '@allocab/allocab-icons';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { TripPackageStatusFilter } from '../../../routes/_authenticated._main.trips.trip-package/TripPackageStatusFilter';
import { usePackagesFilters } from '../../../routes/_authenticated._main.trips.trip-package/usePackagesFilters';
import { t } from '../../../services/translation/translation';
import { FilterIcon } from '../../icons/FilterIcon';

export const SideBarTripPackageFilter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { handleChange, handleReset } = usePackagesFilters();

  const handleChangeFilter = (key: string, value: string | undefined) => {
    handleChange(key, value);
    setIsOpen(false);
  };

  return (
    <div className="flex flex-row justify-end">
      <button onClick={() => setIsOpen(true)} type="button" className="mb-2 rounded-lg">
        <FilterIcon />
      </button>
      <aside
        className={twMerge(
          'fixed top-0 left-0 z-40 w-65 h-screen transition-transform overflow-hidden bg-gray-900 bg-opacity-25 inset-0 transform ease-in-out -translate-x-full xl:translate-x-0 max-w-sm',
          isOpen && '-translate-x-0',
        )}
        aria-label="Sidebar"
      >
        <div className="h-full flex flex-col px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700">
          <div className="flex flex-row justify-between">
            <span className="text-2xl">{t('common.filters')}</span>
            <div className="block xl:hidden">
              <button
                onClick={() => setIsOpen(false)}
                type="button"
                className=" bg-gray-100  dark:bg-gray-600 focus:ring-4 focus:outline-none font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2"
              >
                <XmarkSolid className="fill-current" width={12} height={12} />
              </button>
            </div>
          </div>
          <div className="flex flex-col mt-10 justify-between">
            <div className="flex-1 p-5">
              <TripPackageStatusFilter onChange={handleChangeFilter} />
            </div>

            <button
              type="button"
              className=" flex-1 p-5 font-medium text-blue-600 dark:text-blue-500 hover:underline text-sm"
              onClick={() => {
                handleReset();
                setIsOpen(false);
              }}
            >
              {t('common.reset')}
            </button>
          </div>
        </div>
      </aside>
      {isOpen ? (
        <div
          onClick={() => setIsOpen(false)}
          className={
            'fixed overflow-hidden  bg-gray-50 dark:bg-gray-800 bg-opacity-25 dark:bg-opacity-25 inset-0 transform ease-in-out transition-opacity opacity-100 duration-500 -translate-x-0 z-10 cursor-pointer'
          }
        ></div>
      ) : null}
    </div>
  );
};
